import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import Logo from '../assets/amiralogo.png';



function Header() {
  const location = useLocation();

  return (
    <header className="header-container">
      <div className="header-content">
        <div className="logo-section">
          <Link to="/" className="logo-link">
            <img className="logo-placeholder" src={Logo} alt="Sanafir Logo" />
            <div className="brand-text">
              <h1 className="brand-name">SANAFIR GOLD</h1>
            </div>
          </Link>
        </div>
        
        <nav className="navigation">
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
          <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>About Us</Link>
          <Link to="/gold-jewellery" className={`nav-link ${location.pathname === '/gold-jewellery' ? 'active' : ''}`}>Gold Jewellery</Link>
          <Link to="/diamond-jewellery" className={`nav-link ${location.pathname === '/diamond-jewellery' ? 'active' : ''}`}>Diamond Jewellery</Link>
          <Link to="/gold-rate" className={`nav-link ${location.pathname === '/gold-rate' ? 'active' : ''}`}>Gold Rate</Link>
          <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact Us</Link>
        </nav>
        
      </div>
    </header>
  );
}

export default Header;
